import { MaybeMatch } from '@nf/utils-common/fpw/monadic';

import { PageLoadingSpinner } from '@/components/core/loading-spinner';
import { MainFooter } from '@/components/layout/main-footer';
import { NoGamesManager } from '../no-games-manager';

interface SportPageWrapperPrpos {
    isLoading: boolean;
    hasData: boolean;
	isThirdParty: boolean;
    children: React.ReactNode;
}

export const SportPageWrapper = ({ isLoading, hasData, isThirdParty, children }: SportPageWrapperPrpos) => {
	return isLoading && !isThirdParty ? (
		<PageLoadingSpinner />
	) : (
		MaybeMatch(hasData || isThirdParty)
			.fold(
				() => <NoGamesManager />,
				() => (
					<>
						{children}
						{
							!isThirdParty ? <MainFooter /> : null
						}
					</>
				)
			)
	);
};